import React from "react";
import { Route, Routes } from "react-router-dom";

import { filterLiveArticles } from "supercell-frontend-base/src/utils/targeting/filter-live-articles";

import { EsportView } from "./view";

import { EsportArticle } from "./esport-article";

export const EsportController = () => {
    return (
        <Routes>
            <Route path="/:id/:slug/:variant" element={<EsportArticle />} />

            <Route path="/:id/:slug" element={<EsportArticle />} />

            <Route path="/:id" element={<EsportArticle />} />

            <Route
                path="/"
                element={<EsportView filterArticles={filterLiveArticles} />}
            />
        </Routes>
    );
};
